// import pacchetti
import { useState } from "react";
import { timestamp } from "../../firebase/config";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { it } from "date-fns/locale";

// import hooks
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";

// import componenti
import Avatar from "../../components/Avatar";

export default function ProjectComments({ prj }) {
  const { user } = useAuthContext();
  const { updateDocument, response } = useFirestore("projects");
  const [messaggio, setMessaggio] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const commentToAdd = {
      autore: user.displayName,
      photoURL: user.photoURL,
      commento: messaggio,
      dataCreazione: timestamp.fromDate(new Date()),
      id: Math.random(),
    };
    await updateDocument(prj.id, {
      comments: [...prj.comments, commentToAdd],
    });
    if (!response.error) {
      setMessaggio("");
    }
  };

  return (
    <div className="project-comments">
      <ul>
        {prj.comments.length > 0 &&
          prj.comments.map((commento) => (
            <li key={commento.id}>
              <div className="comment-author">
                <Avatar src={commento.photoURL} />
                <p>{commento.autore}</p>
              </div>
              <div className="comment-date">
                <p>
                  {formatDistanceToNow(commento.dataCreazione.toDate(), {
                    addSuffix: true,
                    locale: it,
                  })}
                </p>
              </div>
              <div className="comment-content">
                <p>{commento.commento}</p>
              </div>
            </li>
          ))}
      </ul>
      <form className="add-comment" onSubmit={handleSubmit}>
        <label>
          <span>Aggiungi commento</span>
          <textarea
            required
            onChange={(e) => setMessaggio(e.target.value)}
            value={messaggio}
          ></textarea>
        </label>
        <button className="btn">Add Comment</button>
      </form>
      <br />
    </div>
  );
}
